export const matchStats = JSON.parse(`{
    "classifications": [
        {
            "id": "GS0005W026T1ZSb",
            "names": {
                "short": "SO",
                "default": "Oportunidades de gol"
            },
            "statKey": "scoringOpportunities",
            "sort": "DESC",
            "order": 3,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZSh",
            "names": {
                "default": "Faltas en contra",
                "short": "FA"
            },
            "statKey": "foulsAgainst",
            "sort": "DESC",
            "order": 4,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZSm",
            "names": {
                "short": "PK",
                "default": "Penaltis"
            },
            "statKey": "penaltyKicks",
            "sort": "DESC",
            "order": 5,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZSr",
            "names": {
                "default": "Paradas del portero",
                "short": "SK"
            },
            "statKey": "savesByGoalkeeper",
            "sort": "DESC",
            "order": 6,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZSt",
            "names": {
                "short": "SE",
                "default": "Saques de esquina"
            },
            "statKey": "corners",
            "sort": "DESC",
            "order": 7,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZT0",
            "names": {
                "short": "TL",
                "default": "Tiros libres"
            },
            "statKey": "freeKicks",
            "sort": "DESC",
            "order": 8,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZT1",
            "names": {
                "default": "Tarjetas amarillas",
                "short": "YC"
            },
            "statKey": "cardsYellow",
            "sort": "DESC",
            "order": 9,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZT2",
            "names": {
                "default": "Tarjetas rojas",
                "short": "RC"
            },
            "statKey": "cardsRed",
            "sort": "DESC",
            "order": 10,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZT3",
            "names": {
                "short": "SW",
                "default": "Tiros fuera"
            },
            "statKey": "shotsWide",
            "sort": "DESC",
            "order": 11,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZT4",
            "names": {
                "default": "Fueras de juego",
                "short": "OS"
            },
            "statKey": "offsides",
            "sort": "DESC",
            "order": 12,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZT5",
            "names": {
                "short": "SG",
                "default": "Tiros a puerta"
            },
            "statKey": "shotsOnGoal",
            "sort": "DESC",
            "order": 13,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZT6",
            "names": {
                "default": "Faltas cometidas",
                "short": "FC"
            },
            "statKey": "fouls",
            "sort": "DESC",
            "order": 14,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZT7",
            "names": {
                "default": "Tiros bloqueados",
                "short": "TB"
            },
            "statKey": "shotsBlocked",
            "sort": "DESC",
            "order": 15,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZT8",
            "names": {
                "short": "TT",
                "default": "Tiros al travesaño"
            },
            "statKey": "hitsWoodwork",
            "sort": "DESC",
            "order": 16,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZT9",
            "names": {
                "short": "TP",
                "default": "Tiros al poste"
            },
            "statKey": "hitsPost",
            "sort": "DESC",
            "order": 17,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZTB",
            "names": {
                "default": "Tiros al larguero",
                "short": "TL"
            },
            "statKey": "hitsBar",
            "sort": "DESC",
            "order": 18,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZTC",
            "names": {
                "default": "No sale por línea de fuera gracias al jugador",
                "short": "SP"
            },
            "statKey": "savesByPlayer",
            "sort": "DESC",
            "order": 19,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZTG",
            "names": {
                "short": "G",
                "default": "Goles"
            },
            "statKey": "goals",
            "sort": "DESC",
            "order": 22,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZTH",
            "names": {
                "short": "BP",
                "default": "Posesión del balón"
            },
            "statKey": "ballPossession",
            "sort": "DESC",
            "order": 23,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZTN",
            "names": {
                "short": "TP",
                "default": "Pases totales"
            },
            "statKey": "passesTotal",
            "sort": "DESC",
            "order": 26,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZTP",
            "names": {
                "default": "Precisión de pases",
                "short": "PAC"
            },
            "statKey": "passAccuracy",
            "sort": "DESC",
            "order": 27,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZTW",
            "names": {
                "short": "SD",
                "default": "Regates con éxito"
            },
            "statKey": "dribblesSuccess",
            "sort": "DESC",
            "order": 32,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZTX",
            "names": {
                "short": "ST",
                "default": "Entradas ganadas"
            },
            "statKey": "tacklesWon",
            "sort": "DESC",
            "order": 33,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZTZ",
            "names": {
                "short": "C",
                "default": "Centros"
            },
            "statKey": "crosses",
            "sort": "DESC",
            "order": 34,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZTb",
            "names": {
                "default": "Intercepciones",
                "short": "I"
            },
            "statKey": "interceptions",
            "sort": "DESC",
            "order": 35,
            "participantType": "TEAM"
        },
        {
            "id": "GS0005W026T1ZTh",
            "names": {
                "short": "TT",
                "default": "Tiros totales"
            },
            "statKey": "shotsTotal",
            "sort": "DESC",
            "order": 36,
            "participantType": "TEAM"
        }
    ],
    "teams": [
        {
            "id": "GN1HA5EQ6XQ88SQ",
            "names": {
                "default": "Ucrania",
                "full": "Ucrania",
                "short": "Ucrania",
                "abbreviation": "UKR"
            },
            "typeDetail": "TEAM_NATIONAL",
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3095.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3095.png"
            },
            "nationality": {
                "names": {
                    "default": "Ucrania",
                    "abbreviation": "UKR"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                }
            },
            "properties": {},
            "stats": {
                "cardsRed": "0",
                "freeKicks": "9",
                "savesByPlayer": "0",
                "fouls": "9",
                "savesByGoalkeeper": "3",
                "foulsAgainst": "8",
                "cardsYellow": "1",
                "crosses": "12",
                "hitsBar": "0",
                "corners": "5",
                "shotsOnGoal": "8",
                "passAccuracy": "87",
                "passesTotal": "448",
                "shotsTotal": "17",
                "shotsBlocked": "3",
                "hitsPost": "0",
                "penaltyKicks": "1",
                "offsides": "3",
                "goals": "2",
                "hitsWoodwork": "0",
                "ballPossession": "52",
                "dribblesSuccess": "6",
                "interceptions": "12",
                "scoringOpportunities": "5",
                "shotsWide": "6",
                "tacklesWon": "13"
            }
        },
        {
            "id": "GN1R063FGB6VT6V",
            "names": {
                "short": "Macedonia",
                "full": "República de Macedonia del Norte",
                "abbreviation": "MKD",
                "default": "República de Macedonia del Norte"
            },
            "typeDetail": "TEAM_NATIONAL",
            "images": {
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3092.png",
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3092.png"
            },
            "nationality": {
                "names": {
                    "default": "República de Macedonia del Norte",
                    "abbreviation": "MKD"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                }
            },
            "properties": {},
            "stats": {
                "cardsRed": "0",
                "freeKicks": "11",
                "savesByPlayer": "0",
                "fouls": "9",
                "savesByGoalkeeper": "7",
                "foulsAgainst": "8",
                "cardsYellow": "2",
                "crosses": "14",
                "hitsBar": "1",
                "corners": "5",
                "shotsOnGoal": "5",
                "passAccuracy": "84",
                "passesTotal": "398",
                "shotsTotal": "13",
                "shotsBlocked": "2",
                "hitsPost": "0",
                "penaltyKicks": "1",
                "offsides": "1",
                "goals": "1",
                "hitsWoodwork": "1",
                "ballPossession": "48",
                "dribblesSuccess": "11",
                "interceptions": "11",
                "scoringOpportunities": "3",
                "shotsWide": "6",
                "tacklesWon": "16"
            }
        }
    ]
}`);


// WEBPACK FOOTER //
// ./src/mundial/requests/mockData/matchStats.ts